<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body,html{
  position: relative;
  font: 12px/1.5 microsoft yahei,arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  background-color: #fff;
  min-width: 1200px;
  color: #323232;
  min-height: 100%;
  box-sizing: border-box;
  margin:0;
  padding:0;
  height: 100%;
  color:#4f4f4f;
}
a{
  text-decoration: none;
  font-size:14px;
  cursor: pointer;
  outline: none;
  color: inherit;
}
ul,ol,dl,dt,dd,h1,h2,h3,h4,h5,h6,p{list-style: none;margin:0;padding:0;}
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: 'Microsoft YaHei',Arial,Helvetica,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /*color: #2c3e50;*/
  height: 100%;
}
.doc_main_h1{
  font-size: 30px;
    padding: 16px 0;
    border: none;
    font-weight: 700;
    margin: 0;
    line-height: 1.25;
}
.doc_main_h2{
  font-size: 24px;
    padding: 12px 0;
    border: none;
    font-weight: 700;
    margin: 0;
    line-height: 1.25;
    margin-bottom: 12px
}
.doc_main_h3{
  font-size: 18px;
    line-height: 40px;
    margin: 0;
    font-weight: 600;
    margin-top:15px;
}
.doc_main_h4{
    font-size: 15px;
    line-height: 40px;
    margin: 0;
    margin-top:15px;  
}
.doc_main_p{
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 5px;
}
.doc_main_pre{
    font-family:Arial,Helvetica,sans-serif;
    background-color: #f5f5f5;
    padding: 20px;
    font-size: 14px;
    line-height: 28px;
    border-radius: 0;
}
.doc_main_code{
    font-family:Arial,Helvetica,sans-serif;
    background-color: transparent;
    display: inline;
    max-width: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    line-height: inherit;
    word-wrap: normal;
    background-color: transparent;
    border: 0;
    font-size: 100%;
    word-break: normal;
    white-space: pre;
    background: transparent;
}
.indent_left_10{
  padding-left: 10px;
}
.indent_left_20{
  padding-left: 20px;
}
.indent_left_30{
  padding-left: 30px;
}
.indent_left_80{
  padding-left: 80px;
}
.doc_main_link a{
  color:#228FFD;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/App.vue